export const EMPTY_PROPS = {};
export const EMPTY_ARRAY = [];
export const EMPTY_FUNCTION = () => ({});
export const FORMAT_FUNCTION = value => value;
export const DATE_PROP = new Date();